<template>
  <FreeCarouselItemLegacy>
    <div class="base-shadow bg-background-neutral-secondary rounded-2xl">
      <div class="min-h-20 w-full p-1">
        <img
          class="w-full rounded-xl"
          height="80"
          :src="getCityImgSrc(arrivalPoint.airport, dict)"
          :alt="`Изображение города ${arrivalPoint.city}`"
        />
      </div>
      <div
        class="text-text-neutral-primary mb-2 mt-3 space-y-1 px-4 text-base font-semibold"
      >
        <div
          class="flex w-fit gap-1"
        >
          <div class="flex flex-col items-start">
            <p>{{ departurePoint.city }}</p>
            <p class="text-situational-grey text-xs font-medium">
              {{ departurePoint.airport }}
            </p>
          </div>
          <p>—</p>
          <div class="flex flex-col items-start">
            <p>{{ arrivalPoint.city }}</p>
            <p class="text-situational-grey text-xs font-medium">
              {{ arrivalPoint.airport }}
            </p>
          </div>
        </div>
        <div class="flex items-center justify-between">
          <div class="flex space-x-6">
            <div>
              <p
                class="text-text-neutral-primary"
              >
                {{ `${departureTime} — ${arrivalTime}` }}
              </p>
              <div
                class="text-situational-grey flex justify-between text-xs font-medium"
              >
                <span>{{ departurePoint.dayOfMonth }}</span>
                <span>{{ arrivalPoint.dayOfMonth }}</span>
              </div>
            </div>
            <div>
              <p
              >
                {{ transfersAmountText }}
              </p>
              <p class="text-situational-grey text-xs font-medium">
                {{ flight.durationText }}
              </p>
            </div>
          </div>
          <AirlineIconsGroup :airlines="uniqueAirlines" />
        </div>
        <!-- TODO: временное решение для FS ручной клади, удалить позже -->
        <button
          v-if="!!foundNewHandLuggageSegment"
          class="flex w-full items-center rounded-2xl border px-3 py-2 text-left"
          @click.stop="$emit('onNewHandLuggageClick')"
        >
          <AirlineIcon :airline="{ iata: 'FS', title: 'FS' }" class="mr-2" />
          <div>
            <p>
              <span class="text-text-neutral-primary text-sm font-semibold">{{
                t('detailsCarouselCard.newHandLuggage', newHandLuggageValue)
              }}</span>
              <span
                class="bg-button-primary-default ml-1 rounded-lg px-1.5 py-0.5 text-xs font-medium text-white"
              >
                {{ t('detailsCarouselCard.increasedBy') }}
              </span>
            </p>
            <p class="text-situational-darkgrey text-xs">
              {{ t('detailsCarouselCard.increasedFromMarch') }}
            </p>
          </div>
          <img
            src="../../../assets/images/chevron-arrow.svg"
            width="20"
            height="20"
            alt=""
            class="ml-auto"
          />
        </button>
      </div>
      <div
        class="p-2"
      >
        <FreeButton size="sm" type="button" class="gray-button w-full">
          {{ t('detailsCarouselCard.flightDetails') }}
        </FreeButton>
      </div>
    </div>
  </FreeCarouselItemLegacy>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { ticketDetails } from 'shared';
  import type { Dict } from '@aviata/platform-types';

  import { AirlineIconsGroup } from '../../../entities/airline-icons';
  import {
    FreeButton,
    FreeCarouselItemLegacy,
    AirlineIcon,
  } from '../../../shared/ui';
  import { getCityImgSrc } from '../lib';

  const props = defineProps<{
    flightIdx?: number;
    flight: ticketDetails.types.MappedFlight;
    dict?: Dict.Entity;
    sourcePage?: string;
  }>();

  defineEmits<{
    (e: 'onNewHandLuggageClick'): void;
  }>();

  const { t } = useI18n();

  /* eslint-disable vue/no-setup-props-destructure */
  const departurePoint = props.flight.segments[0].dep;
  const arrivalPoint = props.flight.segments.slice(-1)[0].arr;
  const departureTime = departurePoint.time;
  const arrivalTime = arrivalPoint.time;
  const uniqueAirlines = ticketDetails.lib.getUniqueAirlines(props.flight);
  const transfersAmountText =
    props.flight.segments.length === 1
      ? t('detailsCarouselCard.direct')
      : t('detailsCarouselCard.transfers', props.flight.segments.length - 1);

  //TODO: временное решение для FS ручной клади, удалить позже
  //с 1 марта 2026 для FS ручная кладь стала больше 5кг->7кг, поэтому необходимо отображать новые значения для пользователей.
  const foundNewHandLuggageSegment = computed(() =>
    props.flight.segments.find(segment => segment.hand_luggage?.new_value),
  );

  const newHandLuggageValue = computed(
    () => foundNewHandLuggageSegment.value?.hand_luggage?.new_value,
  );
</script>

<i18n src="../config/locales.json"></i18n>
